<template>
	<div style="padding: 10px;min-width: 1400px;">
		<el-row :gutter="20">
			<el-col :span="6"> 
				<el-input clearable placeholder="请输入编号" v-model="searchInfo.orderno">
					<template slot="prepend">编号</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-input clearable placeholder="请输入客户名称" v-model="searchInfo.customname">
					<template slot="prepend">客户名称</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-input clearable placeholder="请输入客户电话" v-model="searchInfo.customtel">
					<template slot="prepend">客户电话</template>
				</el-input>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;" :gutter="20">

			<el-col :span="6">
				<el-input clearable placeholder="请输入配送人名称" v-model="searchInfo.sendername">
					<template slot="prepend">配送人名称</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-input clearable placeholder="请输入配送人电话" v-model="searchInfo.sendertel">
					<template slot="prepend">配送人电话</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-select clearable style="width: 100%;" v-model="searchInfo.state" filterable placeholder="订单状态">
				    <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;" :gutter="20">
			<el-col :span="6">
				<el-select clearable style="width: 100%;" v-model="searchInfo.stallID" filterable placeholder="请选择档口">
				    <el-option v-for="item in stallList" :key="item.stall_id" :label="item.stall_name" :value="item.stall_id"> </el-option>
				</el-select>
			</el-col>
			<!-- <el-col :span="6">
				<el-select clearable style="width: 100%;" v-model="searchInfo.canceloperator" filterable placeholder="是否有退款">
				    <el-option v-for="item in canceloperatorList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
			</el-col> -->
			<el-col :span="4">
				<el-select clearable style="width: 100%;" v-model="searchInfo.timevalue" filterable placeholder="请选择时间">
				    <el-option v-for="item in timeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="9"> 
				  <el-button type="primary" @click="searchOrders" icon="el-icon-search">搜索</el-button>
				  <el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				  <el-button type="primary" icon="el-icon-tickets" @click="exportRefundOrders">导出退款订单</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="orderList"  style="width: 100%;" height="650">
			    <el-table-column fixed="left" prop="code" label="菜品" width="650" align="center">
					<template slot-scope="scope">
						<el-row style="background-color: #F2F2F2;font-size: 12px;">
							<el-col :span="9">
								订单号：<span style="">{{scope.row.orderno}}</span>
							</el-col>
							<el-col :span="9">
								下单时间：<span style="">{{scope.row.ordertime}}</span>
							</el-col>
							<el-col :span="6">
								买家：<span style="color: #409EFF;">{{scope.row.orderwechatname}}</span>
							</el-col>
							<!-- <el-col :span="6">
								退款原因：<span style="color: #409EFF;">{{scope.row.refundreason}}</span>
							</el-col>
							<el-col :span="6">
								退款金额：<span style="color: #409EFF;">{{scope.row.refundamount}}</span>
							</el-col> -->
						</el-row>
						<el-row style="margin-top: 10px;" v-for="(food) in scope.row.foods" :key="scope.row.orderno + food.foods_id">
							<el-col :span="16" >
								<div style="width: 100px;float: left;">
									<el-image style="width: 80px; height: 80px;border-radius: 10px;" :src="food.foods_image"  fit="cover"></el-image>
								</div>
								<div style="float: left;text-align: left;">
									<p style="color: #409EFF;font-size: 12px;">{{food.foods_name}}</p>
									<p style="font-size: 12px;">规格：{{food.foods_spec}}</p>
								</div>
							</el-col>
							<el-col :span="4">
								<p>￥{{food.foods_price}}</p>
							</el-col>
							<el-col :span="4">
								<p>x{{food.foods_unmber}}</p>
							</el-col>
						</el-row>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="refundreason" label="退款原因"  width="120" align="center"></el-table-column>
				<el-table-column prop="refundamount" label="退款金额(元)"  width="120" align="center"></el-table-column> -->
			    <el-table-column prop="type" label="配送地址" width="120" align="center">
					<template slot-scope="scope">
						<p>{{scope.row.sendarea}}</p> 
						<p>{{scope.row.sendaddress}}</p>
					</template>
				</el-table-column>
			    <el-table-column prop="deliverpersonname" label="配送员"  width="120" align="center"></el-table-column>
			    <el-table-column prop="orderpayedamount" label="订单总支付金额(元)" align="center">
					<template slot-scope="scope">
						￥{{scope.row.orderpayedamount}}
					</template>
				</el-table-column>
			    <el-table-column prop="orderamount" label="订单总金额(元)" align="center">
					<template slot-scope="scope">
						￥{{scope.row.orderamount}}
					</template>
				</el-table-column>
				<el-table-column prop="statename" label="订单状态" width="120" align="center"></el-table-column>
			    <el-table-column prop="paystatename" label="交易状态" align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<a @click="goDetail(scope.$index, scope.row)" title="订单详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-dish">订单详情</i>
						</a>
						<a v-show="scope.row.state != 'cancel' && scope.row.state != 'overed' && scope.row.paystate == 'payed' && scope.row.isrefund != 'y'" @click="cancelOrders(scope.$index, scope.row)" title="退单" style="display:inline-block;cursor:pointer;color: #409EFF;margin-left: 20px;">
							<i class="el-icon-remove">退单</i>
						</a>
						<a v-show="scope.row.state != 'cancel' && scope.row.paystate == 'payed' && scope.row.isrefund != 'y'" @click="refundOrders(scope.$index, scope.row)" title="退款" style="display:inline-block;cursor:pointer;color: #409EFF;margin-left: 20px;">
							<i class="el-icon-back">填退款信息</i>
						</a>
						<!-- <a v-show="scope.row.state == 'cancel'" @click="cancelOrders(scope.$index, scope.row)" title="退款" style="display:inline-block;cursor:pointer;color: #409EFF;margin-left: 20px;">
							<label style="color: red;">已退款</label>
						</a> -->
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="Total" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog :destroy-on-close="false" title="订单详情" width="80%" :visible.sync="orderdetailShow">
			<OrderDetail :orderno="selectorderno"></OrderDetail>
		</el-dialog>
		<el-dialog @close="refrashData" :destroy-on-close="false" :title="refunddetailTitle" width="40%" :visible.sync="orderrefundShow">
			<OrderRefund @needRefrash="needRefrash_Refund" :orderno="selectorderno"></OrderRefund>
		</el-dialog>
	</div>
</template>

<script>
	import dayjs from 'dayjs'
	import {nfsprefix, baseUrl } from '/static/baseUrl.js'
	import {queryStallLists,queryRefundOrdersList,exportRefundOrderData,cancelOrder } from '/static/apiUrl.js'
	import OrderDetail from './orderdetail'
	import OrderRefund from './orderrefund.vue';
	export default {
		name : 'refundorderList',
		data() {
			return {
				orderdetailShow: false,
				orderrefundShow: false,
				editok : false,
				detailTitle: '订单详情',
				refunddetailTitle: "订单退款",
				selectorderno : '',
				searchInfo:{
					orderno : '',
					state: '',
					canceloperator: '',
					stallID: '',
					customname : '',
					customtel: '',
					sendername: '',
					sendertel : '',
					timevalue: '0',					
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				stateList : [
					{
						label : '待出餐',
						value : 'notdining',
					},
										{
						label : '待配送',
						value : 'notsend',
					},
										{
						label : '配送中',
						value : 'sending',
					},
					{
						label : '待取餐',
						value : 'sended',
					},
					{
						label : '已取餐',
						value : 'pickuped',
					},
					{
						label : '已结束',
						value : 'overed',
					},
					{
						label : '已取消',
						value : 'cancel',
					},
					{
						label : '待退款',
						value : 'refund',
					},
				],
				paystateList : [
					{
						label : '已支付',
						value : 'payed',
					},
					{
						label : '未支付',
						value : 'notpay',
					},
				],
				canceloperatorList: [
					{
						label : '所有已支付订单',
						value : '',
					},
					{
						label : '平台取消',
						value : 'platform',
					},
					{
						label : '客户取消',
						value : 'custom',
					},
				],			
				timeList: [
					{
						label : '全部日期',
						value : '0',
					},
					{
						label : '今天',
						value : '1',
					},
					{
						label : '昨天',
						value : '2',
					},
					{
						label : '本周',
						value : '3',
					},
					{
						label : '本月',
						value : '4',
					},
					{
						label : '本季度',
						value : '5',
					},
					{
						label : '本年',
						value : '6',
					},
				],
				Total : 0,
				orderList : [
				],
				stallList : []				
			}
		},
		mounted() {
			this.initData()
			this.queryOrders()
		},
		components: {
			OrderDetail,
			OrderRefund
		},
		methods: {
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.queryOrders()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.queryOrders()
			},	
			cancelOrders(idx, row) {
				console.log(idx, row)
				this.$prompt('请输入您的密码', '提示', {
					inputType: 'password',
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({ value }) => {
					cancelOrder({
						orderno : row.orderno,
						userpwd : this.$md5(value)
					}).then(res => {
						console.log(res)
						if(0 == res.code){
							row.statename = '已取消'
							row.state = 'cancel'
							this.$message({
								type: 'success',
								message: '取消成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch(() => { });
			},	
			refundOrders(idx, row) {
				console.log(idx,row)
				this.refunddetailTitle = "订单退款"
				this.selectorderno = row.orderno
				this.orderrefundShow = true
			},				
			initData() {
				queryStallLists({
					state: "normal",
					offset: 0,
					limit: 100
				}).then(res => {
					console.log(res)
					if (0 == res.code) {
						this.stallList = res.data.data
					}
				})
			},
			searchOrders(){
				this.param.page = 1
				this.orderList = []
				this.queryOrders()
			},
			clearSearch(){
				this.searchInfo.orderno = '';
				this.searchInfo.state = ''
				this.searchInfo.canceloperator = ''
				this.searchInfo.stallID = ''
				this.searchInfo.customname = ''
				this.searchInfo.customtel = ''
				this.searchInfo.sendername = ''
				this.searchInfo.sendertel = ''
				this.searchInfo.timevalue = '0'
				this.param.page = 1
				this.queryOrders()
			},
			queryOrders() {
				this.orderList = []
				queryRefundOrdersList({					
					orderno : this.searchInfo.orderno,
					state: this.searchInfo.state,
					canceloperator: this.searchInfo.canceloperator,
					stall_id: this.searchInfo.stallID,
					customname: this.searchInfo.customname,
					customtel: this.searchInfo.customtel,
					sendername: this.searchInfo.sendername,
					sendertel: this.searchInfo.sendertel,
					timevalue: this.searchInfo.timevalue,			
					offset : (this.param.page - 1) * this.param.pagenum,
					limit : this.param.pagenum
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.Total = res.data.total
						res.data.data.forEach((item) => {
							let statename = '';
							if (item.stallsorders_state == 'notpay') {
								statename = '待支付';
							} else if (item.stallsorders_state == 'notdining') {
								statename = '待出餐';
							} else if (item.stallsorders_state == 'notsend') {
								statename = '待配送';
							} else if (item.stallsorders_state == 'sending') {
								statename = '配送中';
							} else if (item.stallsorders_state == 'sended') {
								statename = '待取餐';
							} else if (item.stallsorders_state == 'pickuped') {
								statename = '已取餐';
							} else if (item.stallsorders_state == 'overed') {
								statename = '已结束';
							} else if (item.stallsorders_state == 'cancel') {
								statename = '已取消';
							}	

							if (item.service_stalls.length == 0) {
								return
							}
							else {
								item.service_stalls.forEach((item) => { 
									item.service_foods.forEach((food) => { 
										food.foods_image = baseUrl + nfsprefix + food.foods_image
									})
								})
							}
							console.log(item.stallsorders_orderno + " " + item.stallsorders_amount);
							this.orderList.push({
								id: item.stallsorders_id,
								orderno: item.stallsorders_orderno,
								ordertime: item.stallsorders_ordertime == null ? "" : dayjs(item.stallsorders_ordertime).format('YYYY-MM-DD HH:mm:ss'),
								payendlinetime: item.stallsorders_payendlinetime == null ? "" : dayjs(item.stallsorders_payendlinetime).format('YYYY-MM-DD HH:mm:ss'),
								totalamount: item.stallsorders_totalamount,
								undiscountamount: item.stallsorders_undiscountamount,
								discountamount: item.stallsorders_discountamount,
								packprice: item.stallsorders_packprice,
								orderpayedamount: item.stallsorders_orderpayedamount,
								orderamount: item.stallsorders_orderamount,
								state: item.stallsorders_state,
								statename: statename,
								paystate: item.stallsorders_paystate,
								paystatename: item.stallsorders_paystate == "payed" ? "已支付" : "未支付",
								dangkou: item.stallsorders_dangkou,
								ownbusiness: item.stallsorders_ownbusiness,
								stallname: item.service_stallname,
								ownbusinessname: item.service_ownbusinessname,
								ownplatform: item.stallsorders_ownplatform,
								orderwechatname: item.stallsorders_orderwechatname,
								telphone: item.stallsorders_telphone,
								sendarea: item.stallsorders_sendarea,
								sendaddress: item.stallsorders_sendaddress,
								deliverfee: item.stallsorders_deliverfee,
								deliverpersonname: item.stallsorders_deliverpersonname,
								deliverpersontelphone: item.stallsorders_deliverpersontelphone,
								platefromnumber: item.stallsorders_platefromnumber,
								remark: item.stallsorders_remark,
								foodcategory: item.service_foodcategory,
								foods: item.service_stalls[0].service_foods,
								refundreason: item.stallsorders_refundreason,
								refundamount: item.stallsorders_refundamount,
							})
						})
					}
				})
			},
			goDetail(idx,row){
				this.detailTitle = '订单详情'
				console.log(idx,row)
				this.selectorderno = row.orderno
				this.orderdetailShow = true
			},
			exportRefundOrders(){
				exportRefundOrderData({
					orderno : this.searchInfo.orderno,
					state: this.searchInfo.state,
					stall_id: this.searchInfo.stallID,
					customname: this.searchInfo.customname,
					customtel: this.searchInfo.customtel,
					sendername: this.searchInfo.sendername,
					sendertel: this.searchInfo.sendertel,
					timevalue: this.searchInfo.timevalue,	
				}).then(res => {
					if (0 == res.code) {
						this.downLoad(res.data);
					} else {
						this.$message({ type: 'error', message: res.msg });
					}
				})
			},
			downLoad(filename){			
				var a = document.createElement("a");
				a.href = baseUrl + nfsprefix + "/orders/" + filename;
				// a.target = "_blank";
				a.download = filename;
				a.style.display = "none";
				document.body.appendChild(a);
				a.click();
				a.remove();
			},
			saveAs(res){
				// const {headers, data} = res
				// const filename = decodeURI(headers["content-disposition"].split("filename=")[1])
				// const blob = new Blob([data], {type: headers["content-type"]});
				// if (blob) {
				// 	const a = document.createElement('a');
				// 	a.href = window.URL.createObjectURL(blob);
				// 	// a.target = '_blank';
				// 	a.style.display = 'none'
				// 	a.setAttribute('download', "Foods.xlsx")
				// 	document.body.appendChild(a)
				// 	a.click()
				// 	window.URL.revokeObjectURL(a.href); //释放URL对象
				// 	document.body.removeChild(a);
				// 	a.remove()
				// }

				const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = "退款订单.txt";
				link.click();
				window.URL.revokeObjectURL(link.href);
				link.remove();
			},
			needRefrash(val){
				console.log(val)
				this.editok = val
			},
			needRefrash_Refund(val, isshow) {
				console.log(val, isshow)
				this.editok = val
				this.orderrefundShow = isshow
			},			
			refrashData(){
				console.log('ddd')
				if(this.editok){
					this.queryOrders()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>